import { DrawingType, DropLocationUpdateDetails } from '../constants';
import { getNewId } from 'utils/Global';
import { getCanvasPointerPosition } from '../utils';
import TransformPoints from 'components/plateviewer/well/TransformPoints';
import useCurrentRegionIds from 'CustomHooks/useCurrentRegionIds';

let dropLocationDrawing: DropLocationUpdateDetails = null;
let isDrawingFirstClick: boolean = false;

export const useDropLocationCreateHandlers = (tpObject: TransformPoints) => {
  const [regionId] = useCurrentRegionIds();
  const onMouseDown: (e) => { drawing: DropLocationUpdateDetails; type: DrawingType } = (
    e,
  ) => {
    const { x, y } = getCanvasPointerPosition(e);
    const [dbX, dbY] = tpObject.FromCanvasToDb(x, y);
    dropLocationDrawing = {
      id: getNewId(),
      x,
      y,
      dbX,
      dbY,
      width: 0,
      height: 0,
      zIndex: 0,
      isNewDrawing: true,
    };
    isDrawingFirstClick = true;
    return null;
  };

  const onMouseMove: (e) => {
    drawing: DropLocationUpdateDetails;
    type: DrawingType;
    isDrawingFirstClick: boolean;
  } = (e) => {
    const { x: newX, y: newY } = getCanvasPointerPosition(e);
    const width = newX - dropLocationDrawing.x;
    const height = newY - dropLocationDrawing.y;
    const {
      x: dbXCenterOffset,
      y: dbYCenterOffset,
      width: dbWidth,
      height: dbHeight,
    } = tpObject.convertRectangleDrawingForDb(
      dropLocationDrawing.x,
      dropLocationDrawing.y,
      width,
      height,
    );
    dropLocationDrawing = {
      ...dropLocationDrawing,
      width,
      height,
      dbXCenterOffset,
      dbYCenterOffset,
      dbWidth,
      dbHeight,
      parentRegionId: regionId,
    };
    const drawingData = {
      drawing: dropLocationDrawing,
      type: DrawingType.DropLocation,
      isDrawingFirstClick,
    };
    isDrawingFirstClick = false;
    return drawingData;
  };

  const onMouseUp: (e) => { drawing: DropLocationUpdateDetails; type: DrawingType } = (
    e,
  ) => {
    if (!isDrawingFirstClick) {
      dropLocationDrawing = {
        ...dropLocationDrawing,
        isNewDrawing: false,
      };
      return { drawing: dropLocationDrawing, type: DrawingType.DropLocation };
    }
    isDrawingFirstClick = false;
    return null;
  };

  return { onMouseDown, onMouseMove, onMouseUp };
};
